import React, { useState, useRef, useEffect } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import ModalConfirm from "./ModalConfirm";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import useFetchHouses from "../../hooks/useFetchHouses";
import useFetchRoutes from "../../hooks/useFetchRoutes ";
import useFeeGroups from "../../hooks/useFeeGroups";
import useFetchPickupPoints from "../../hooks/useFetchPickupPoints ";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const [formData, setFormData] = useState({
    classId: "",
    sectionId: "",
    routeid: "",
    selectedPickUpPoint: "",
    feeappfrom: "",
    feegroup: "",
  });
  const [selectedClassId, setSelectedClassId] = useState("");
  const navigate = useNavigate();

  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();

  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(formData.classId);
  const [studentsData, setStudentsData] = useState([]);

  const [amount, setAmount] = useState("");
  const [previousYearBalance, setPreviousYearBalance] = useState("");

  const [isTransportAvailed, setIsTransportAvailed] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);
  const {
    pickupPoints,
    loading: pickupLoading,
    error: pickupError,
  } = useFetchPickupPoints(formData.routeid);
  const {
    routes,
    loading: routeLoading,
    error: routeError,
  } = useFetchRoutes(isTransportAvailed);
  const [selectedPickUpPoint, setSelectedPickUpPoint] = useState("");

  const [showStudentSelectionModal, setShowStudentSelectionModal] =
    useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const studentNameRef = useRef(null);
  const [periods, setPeriods] = useState([]);
  const {
    houses,
    loading: loadingHouses,
    error: errorHouses,
  } = useFetchHouses();
  const [selectedStudent, setSelectedStudent] = useState(null);
  const {
    feeGroups = [],
    loading: feeLoading,
    error: feeError,
  } = useFeeGroups(formData.classId);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transportData, setTransportData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  // const itemsPerPage = 10;
  // const pageCount = Math.ceil(transportData.length / itemsPerPage);
  // const handlePageClick = (data) => {
  //   const selectedPage = data.selected;
  //   setCurrentPage(selectedPage);
  // };

  useEffect(() => {
    setFormData({
      classId: "",
      sectionId: "",
      routeid: "",
      selectedPickUpPoint: "",
      feeappfrom: "",
      feegroup: "",
    });
  }, []);

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0]?.type;

    const isHardReload = navType === "reload" || navType === "navigate"; // refresh or route enter

    if (isHardReload) {
      localStorage.removeItem("selectedStudentClassId");
      localStorage.removeItem("selectedStudentSectionId");
      localStorage.removeItem("selectedClassConfirmStudentId");
      localStorage.removeItem("status");
    }
  }, []);

  useEffect(() => {
    // Get the academic year ID and student ID from localStorage
    const academicYearId = localStorage.getItem("nextAcademicSessionId");
    const studentId = localStorage.getItem("selectedFeeStudentId");

    if (academicYearId && studentId) {
      // Construct the API URL using the stored values
      const apiUrl = `${ApiUrl.apiurl}STUDENT_CLASS/GetPreviousyearfees/${academicYearId}/${studentId}`;

      // Fetch the previous year fees data
      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          if (data.message === "success!!" && data.data) {
            // Set the previous year balance from the API response
            setPreviousYearBalance(data.data.total_remaining_amount);
          } else {
            console.error("Error fetching previous year balance");
          }
        })
        .catch((error) => {
          console.error("Error fetching previous year balance:", error);
        });
    } else {
      console.error(
        "Academic Year ID or Student ID not found in local storage."
      );
    }
  }, []);

  const modalClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (routes.length > 0 && selectedStudent?.routeid) {
      const routeExists = routes.some(
        (route) => route.id === selectedStudent.routeid
      );
      if (routeExists) {
        setSelectedRoute(selectedStudent.routeid);
      } else {
        setSelectedRoute("");
      }
    }
  }, [routes, selectedStudent]);

  useEffect(() => {
    if (selectedStudent) {
      setFormData((prev) => ({
        ...prev,
        routeid: selectedStudent.routeid || "",
        selectedPickUpPoint: selectedStudent.pickuppoitId || "",
      }));

      setIsTransportAvailed(selectedStudent.transport_availed || false);
      setSelectedPickUpPoint(selectedStudent.pickuppoitId || "");
    }
  }, [selectedStudent]);

  useEffect(() => {
    if (pickupPoints.length > 0 && formData.selectedPickUpPoint) {
      const matchingPoint = pickupPoints.find(
        (point) => point.routeDetailsId === formData.selectedPickUpPoint
      );

      if (matchingPoint) {
        setSelectedPickUpPoint(matchingPoint.routeDetailsId);
      } else {
        setSelectedPickUpPoint("");
      }
    }
  }, [pickupPoints, formData.selectedPickUpPoint]);

  // const handleEditClick = (student) => {
  //   // Store the student ID in localStorage
  //   localStorage.setItem("selectedFeeStudentId", student.studentId);

  //   // Set the selected student in the state
  //   setSelectedStudent(student);

  //   // Show the edit modal
  //   setShowEditModal(true);

  //   // Fetch student details and previous year's fees based on the student ID
  //   const studentId = localStorage.getItem("selectedFeeStudentId");
  //   const academicYearId = localStorage.getItem("academicSessionId");
  //   if (studentId) {
  //     // Fetch student details based on student ID
  //     // fetch(`${ApiUrl.apiurl}STUDENT_CLASS/GetStudentDataBasedId/${studentId}`)
  //     fetch(`${ApiUrl.apiurl}STUDENT_CLASS/GetStudentDataBasedId/${studentId}?academic_year_id=${academicYearId}&is_promoted=True`)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.message === "Success") {
  //           const studentData = data.data;

  //           // Store the student data in localStorage for later use
  //           localStorage.setItem("studentData", JSON.stringify(studentData));

  //           // Update the state with the fetched student data
  //           setSelectedStudent({
  //             studentname: studentData.studentname,
  //             school_admission_no: studentData.school_admission_no,
  //             barcode: studentData.barcode,
  //             father_name: studentData.father_name,
  //             mother_name: studentData.mother_name,
  //             classname: studentData.classname,
  //             sectionname: studentData.sectionname,
  //             rollno: studentData.rollno,
  //             house: studentData.house,
  //             fee_structure_master: studentData.fee_structure_master,
  //             // feeappfrom: studentData.feeappfrom,
  //             transport_availed: studentData.transport_availed || false,
  //             choice_month: studentData.choice_month || [],
  //             routeid: studentData.routeid,
  //             transport_name: studentData.transport_name,
  //             pickuppoitId: studentData.pickuppoitId,
  //             pickuppointname: studentData.pickuppointname,
  //             selectedRoute: studentData.routeid || "",
  //             selectedPickUpPoint: studentData.pickuppoitId,
  //             amount: studentData.amount,
  //           });

  //           // Set the form data for editing
  //           setFormData((prev) => ({
  //             ...prev,
  //             classId: studentData.classId,
  //             sectionId: studentData.sectionId,
  //             rollno: studentData.rollno,
  //             house: studentData.house,
  //             feegroup: studentData.fee_structure_masterId,
  //             // feeappfrom: studentData.feeappfromId,
  //             transportAvailed: studentData.transport_availed || false,
  //             selectedMonths: (studentData.choice_month || []).reduce(
  //               (acc, month) => {
  //                 acc[month.id] = true;
  //                 return acc;
  //               },
  //               {}
  //             ),
  //             selectedRoute: studentData.routeid,
  //             selectedPickUpPoint: studentData.pickuppoitId,
  //             amount: studentData.amount,
  //           }));

  //           // Set the transport availed status
  //           setIsTransportAvailed(studentData.transport_availed || false);

  //           // Fetch previous year fees after fetching student data
  //           const academicYearId = localStorage.getItem(
  //             "nextAcademicSessionId"
  //           );

  //           if (academicYearId) {
  //             fetch(
  //               `${ApiUrl.apiurl}STUDENT_CLASS/GetPreviousyearfees/${academicYearId}/${studentId}`
  //             )
  //               .then((response) => response.json())
  //               .then((data) => {
  //                 if (data.message === "success!!" && data.data) {
  //                   const totalRemainingAmount =
  //                     data.data.total_remaining_amount;

  //                   // Update state
  //                   setPreviousYearBalance(totalRemainingAmount);

  //                   // Store in local storage
  //                   localStorage.setItem(
  //                     "previousYearBalance",
  //                     JSON.stringify(totalRemainingAmount)
  //                   );
  //                 } else {
  //                   console.error("Error fetching previous year balance");
  //                 }
  //               })
  //               .catch((error) =>
  //                 console.error("Error fetching previous year balance:", error)
  //               );
  //           }
  //         } else {
  //           alert("Error fetching student data");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching student data:", error);
  //         alert("Error fetching student data");
  //       });
  //   } else {
  //     console.error("Student ID not found in localStorage");
  //     alert("Student ID not found");
  //   }
  // };

  const handleEditClick = (student) => {
    // 🔹 Reset formData so previous values don’t leak into the new modal
    setFormData({
      classId: "",
      sectionId: "",
      routeid: "",
      selectedPickUpPoint: "",
      feeappfrom: "",
      feegroup: "",
      amount: "",
      house: "",
      rollno: "",
      transportAvailed: false,
      selectedMonths: {},
    });

    // 🔹 Clear fee-related localStorage values before setting new student
    localStorage.removeItem("selectedFeeAppFromId");
    localStorage.removeItem("selectedFeeGroupId");
    localStorage.removeItem("choice_month");
    localStorage.removeItem("selectedRouteId");
    localStorage.removeItem("selectedPickUpPointId");

    // Store the student ID in localStorage
    localStorage.setItem("selectedFeeStudentId", student.studentId);

    // Set the selected student in the state (basic details)
    setSelectedStudent(student);

    // Show the edit modal
    setShowEditModal(true);

    // Fetch student details and previous year's fees based on the student ID
    const studentId = localStorage.getItem("selectedFeeStudentId");
    const academicYearId = localStorage.getItem("academicSessionId");

    if (studentId) {
      fetch(
        `${ApiUrl.apiurl}STUDENT_CLASS/GetStudentDataBasedId/${studentId}?academic_year_id=${academicYearId}&is_promoted=True`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.message === "Success") {
            const studentData = data.data;

            // Store the student data in localStorage for later use
            localStorage.setItem("studentData", JSON.stringify(studentData));

            // Update the state with the fetched student data
            setSelectedStudent({
              studentname: studentData.studentname,
              school_admission_no: studentData.school_admission_no,
              barcode: studentData.barcode,
              father_name: studentData.father_name,
              mother_name: studentData.mother_name,
              classname: studentData.classname,
              sectionname: studentData.sectionname,
              rollno: studentData.rollno,
              house: studentData.house,
              fee_structure_master: studentData.fee_structure_master,
              transport_availed: studentData.transport_availed || false,
              choice_month: studentData.choice_month || [],
              routeid: studentData.routeid,
              transport_name: studentData.transport_name,
              pickuppoitId: studentData.pickuppoitId,
              pickuppointname: studentData.pickuppointname,
              selectedRoute: studentData.routeid || "",
              selectedPickUpPoint: studentData.pickuppoitId,
              amount: studentData.amount,
            });

            //  Reset and set formData fresh from API
            setFormData({
              classId: studentData.classId || "",
              sectionId: studentData.sectionId || "",
              rollno: studentData.rollno || "",
              house: studentData.house || "",
              feegroup: studentData.fee_structure_masterId || "",
              feeappfrom: studentData.feeappfromId || "", // now included
              transportAvailed: studentData.transport_availed || false,
              selectedMonths: (studentData.choice_month || []).reduce(
                (acc, month) => {
                  acc[month.id] = true;
                  return acc;
                },
                {}
              ),
              routeid: studentData.routeid || "",
              selectedRoute: studentData.routeid || "",
              selectedPickUpPoint: studentData.pickuppoitId || "",
              amount: studentData.amount || "",
            });

            // Set the transport availed status
            setIsTransportAvailed(studentData.transport_availed || false);

            // Fetch previous year fees
            const nextAcademicYearId = localStorage.getItem(
              "nextAcademicSessionId"
            );
            if (nextAcademicYearId) {
              fetch(
                `${ApiUrl.apiurl}STUDENT_CLASS/GetPreviousyearfees/${nextAcademicYearId}/${studentId}`
              )
                .then((response) => response.json())
                .then((data) => {
                  if (data.message === "success!!" && data.data) {
                    const totalRemainingAmount =
                      data.data.total_remaining_amount;

                    setPreviousYearBalance(totalRemainingAmount);
                    localStorage.setItem(
                      "previousYearBalance",
                      JSON.stringify(totalRemainingAmount)
                    );
                  }
                })
                .catch((error) =>
                  console.error("Error fetching previous year balance:", error)
                );
            }
          } else {
            alert("Error fetching student data");
          }
        })
        .catch((error) => {
          console.error("Error fetching student data:", error);
          alert("Error fetching student data");
        });
    } else {
      console.error("Student ID not found in localStorage");
      alert("Student ID not found");
    }
  };

  // useEffect to handle the automatic fetch of previous year fees
  useEffect(() => {
    const academicYearId = localStorage.getItem("nextAcademicSessionId");
    const studentId = localStorage.getItem("selectedFeeStudentId");

    if (academicYearId && studentId) {
      const apiUrl = `${ApiUrl.apiurl}STUDENT_CLASS/GetPreviousyearfees/${academicYearId}/${studentId}`;

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          if (data.message === "success!!" && data.data) {
            setPreviousYearBalance(data.data.total_remaining_amount);
          } else {
            console.error("Error fetching previous year balance");
          }
        })
        .catch((error) => {
          console.error("Error fetching previous year balance:", error);
        });
    } else {
      console.error(
        "Academic Year ID or Student ID not found in local storage."
      );
    }
  }, []);

  useEffect(() => {
    if (formData.classId) {
    }
  }, [formData.classId]);

  const [error, setError] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState({});
  useEffect(() => {
    if (formData.transportAvailed) {
      const updatedMonths = formData.selectedMonths || {};
      setSelectedMonths(updatedMonths);
    }
  }, [formData]);

  // const handleModalClose = () => {
  //   // Clear specific fields in localStorage
  //   const fieldsToClear = [
  //     "selectedFeeStudentId",
  //     "studentData",
  //     "selectedFeeAppFromId",
  //     "selectedFeeGroupId",
  //     "transport_availed",
  //     "choice_month",
  //     "selectedRouteId",
  //     "selectedPickUpPointId",

  //     "previousYearBalance",
  //   ];

  //   fieldsToClear.forEach((field) => localStorage.removeItem(field));

  //   // Close the modals
  //   setShowEditModal(false);
  //   setShowStudentSelectionModal(false);

  //   // Refresh the page
  //   // window.location.reload();
  // };

  const handleModalClose = () => {
    // Clear specific fields in localStorage
    const fieldsToClear = [
      "selectedFeeStudentId",
      "studentData",
      "selectedFeeAppFromId",
      "selectedFeeGroupId",
      "transport_availed",
      "choice_month",
      "selectedRouteId",
      "selectedPickUpPointId",
      "previousYearBalance",
      "selectedStudentClassId", // 🔹 also clear classId
      "selectedStudentSectionId", // 🔹 also clear sectionId
    ];

    fieldsToClear.forEach((field) => localStorage.removeItem(field));

    //  Reset class and section in formData
    setFormData((prev) => ({
      ...prev,
      classId: "",
      sectionId: "",
    }));

    //  Reset selectedClassId state too
    setSelectedClassId("");

    // Close the modals
    setShowEditModal(false);
    setShowStudentSelectionModal(false);
  };

  const resetConfirmFilters = () => {
    setFormData({
      classId: "",
      sectionId: "",
      routeid: "",
      selectedPickUpPoint: "",
      feeappfrom: "",
      feegroup: "",
    });
    setSelectedClassId("");
    setSelectedStatus(null);
    setCurrentPage(0);

    if (studentNameRef.current) {
      studentNameRef.current.value = "";
    }

    localStorage.removeItem("selectedStudentClassId");
    localStorage.removeItem("selectedStudentSectionId");
    localStorage.removeItem("selectedClassConfirmStudentId");
    localStorage.removeItem("status");
  };

  const handleSaveChanges = () => {
    const loginId = sessionStorage.getItem("userId");
    const org_id = localStorage.getItem("orgId");
    const branch_id = localStorage.getItem("branchId");
    const academic_year_id = localStorage.getItem("academicSessionId");
    const studentData = JSON.parse(localStorage.getItem("studentData"));

    if (!studentData) {
      alert("No student data found");
      return;
    }

    // Prefer the current form state and fall back to local storage when needed.
    const selectedFeeAppFromId =
      formData.feeappfrom || localStorage.getItem("selectedFeeAppFromId") || "";
    const selectedFeeGroupId =
      formData.feegroup || localStorage.getItem("selectedFeeGroupId") || "";

    if (!selectedFeeAppFromId || !selectedFeeGroupId) {
      alert(" Fee App From and Fee Group are mandatory.");
      return; // Stop the function execution if validation fails
    }

    const updatedStudentData = {
      ...studentData,
      ...formData,
    };

    const normalizeId = (value) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
    };

    const normalizedClassId = normalizeId(
      updatedStudentData.classId ??
        updatedStudentData.class_id ??
        selectedStudent?.classId ??
        selectedStudent?.class_id
    );
    const normalizedSectionId = normalizeId(
      updatedStudentData.sectionId ??
        updatedStudentData.section_id ??
        selectedStudent?.sectionId ??
        selectedStudent?.section_id
    );

    if (!normalizedClassId) {
      alert("Valid Class is required.");
      return;
    }

    if (!normalizedSectionId) {
      alert("Valid Section is required.");
      return;
    }

    const studentId = updatedStudentData.studentId;
    const carryordelete = selectedAction === "Carry Forward" ? "Y" : "N";
    const updateorconfirm = "C";

    const transportAvailed = Boolean(isTransportAvailed);
    const selectedRouteId =
      formData.routeid || selectedRoute || localStorage.getItem("selectedRouteId") || "";
    const selectedPickupPointId =
      formData.selectedPickUpPoint ||
      selectedPickUpPoint ||
      localStorage.getItem("selectedPickUpPointId") ||
      "";

    const choiceMonthIds = Object.keys(selectedMonths)
      .filter((monthId) => selectedMonths[monthId])
      .map((monthId) => parseInt(monthId, 10))
      .filter((monthId) => Number.isInteger(monthId));

    const previousYearBalanceRaw =
      previousYearBalance || localStorage.getItem("previousYearBalance") || "0";

    const normalizedFeeAppFromId = normalizeId(selectedFeeAppFromId);
    const normalizedFeeGroupId = normalizeId(selectedFeeGroupId);

    if (!normalizedFeeAppFromId || !normalizedFeeGroupId) {
      alert("Fee App From and Fee Group must be valid selections.");
      return;
    }

    if (transportAvailed) {
      if (!selectedRouteId) {
        alert("Route is required when Transport Availed is selected.");
        return;
      }

      if (!selectedPickupPointId) {
        alert("Pick Up Point is required when Transport Availed is selected.");
        return;
      }

      if (!normalizeId(selectedPickupPointId)) {
        alert("Selected Pick Up Point is invalid.");
        return;
      }

      if (choiceMonthIds.length === 0) {
        alert("Select at least one month when Transport Availed is selected.");
        return;
      }
    }

    const payload = {
      loginId: loginId,
      org_id: org_id,
      branch_id: branch_id,
      academic_year_id: academic_year_id,
      classId: normalizedClassId,
      sectionId: normalizedSectionId,
      rollno: updatedStudentData.rollno,
      house: updatedStudentData.house || "",
      feestructureId: normalizedFeeGroupId,
      feeappfromId: normalizedFeeAppFromId,
      transportavailed: transportAvailed,
      choicemonthIds: transportAvailed ? choiceMonthIds : [],
      // Backend route-detail expects pickup-point detail id.
      routedetailId: transportAvailed ? normalizeId(selectedPickupPointId) : null,
      amount: updatedStudentData.amount,
      previousyearBalance: previousYearBalanceRaw,
      updateorconfirm: updateorconfirm,
      carryordelete: carryordelete,
      is_promoted: true,
    };

    fetch(`${ApiUrl.apiurl}STUDENT_CLASS/updatestudentclass/${studentId}/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        return response
          .json()
          .catch(() => ({}))
          .then((data) => ({ ok: response.ok, status: response.status, data }));
      })
      .then(({ ok, status, data }) => {
        console.log("API Response:", data);

        if (!ok) {
          const backendMessage =
            data?.error?.non_field_errors?.[0] ||
            data?.error ||
            data?.message ||
            `HTTP error ${status}`;
          throw new Error(backendMessage);
        }

        if (data?.message) {
          alert(data.message);
        } else {
          alert("Operation completed successfully!");
        }

        if (data?.message === "Student Update Successfully!!") {
          localStorage.removeItem("studentData");

          //  Reload the table
          if (typeof handleSearch === "function") {
            handleSearch(); // Replace with your table reload function
          }

          //  Close modal
          setIsModalOpen(false);
          setShowEditModal(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert(error.message || "Failed to update student data. Please try again.");
      });
  };

  // const handleClear = () => {
  //   setFormData({ classId: "", sectionId: "" });
  //   if (studentNameRef.current) {
  //     studentNameRef.current.value = "";
  //   }

  //   // Clear all relevant localStorage keys
  //   localStorage.removeItem("selectedStudentClassId");
  //   localStorage.removeItem("selectedStudentSectionId");
  //   localStorage.removeItem("selectedClassConfirmStudentId");
  //   localStorage.removeItem("status");

  //   // Clear any related state
  //   setStudentsData([]);

  //   // Reset the status dropdown
  //   const statusDropdown = document.getElementById("status");
  //   if (statusDropdown) {
  //     statusDropdown.value = ""; // Reset dropdown to "Select Status"
  //   }
  // };

  const handleClear = () => {
    resetConfirmFilters();
    setStudentsData([]);
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;

    if (classId) {
      localStorage.setItem("selectedStudentClassId", classId);
    } else {
      localStorage.removeItem("selectedStudentClassId");
    }

    setFormData((prev) => ({
      ...prev,
      classId,
      sectionId: "",
    }));

    setSelectedClassId(classId);
  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value;

    if (sectionId) {
      localStorage.setItem("selectedStudentSectionId", sectionId);
    } else {
      localStorage.removeItem("selectedStudentSectionId");
    }

    setFormData((prev) => ({ ...prev, sectionId }));
  };

  useEffect(() => {
    if (selectedClassId) {
    }
  }, [selectedClassId]);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`)
      .then((response) =>
        response.ok ? response.json() : Promise.reject(response.status)
      )
      .then((data) => {
        setPeriods(data.data || []);
        const initialMonths = (data.data || []).reduce((acc, period) => {
          acc[period.id] = false;
          return acc;
        }, {});
        setSelectedMonths(initialMonths);
      })
      .catch(() => setError("Failed to load periods."));
  }, []);

  const fetchConfirmStudents = async ({
    academicYearId = localStorage.getItem("academicSessionId"),
    showNoDataAlert = false,
  } = {}) => {
    const selectedClassId = localStorage.getItem("selectedStudentClassId");
    const statusData = localStorage.getItem("status");
    const selectedSectionId = localStorage.getItem("selectedStudentSectionId");
    const studentId = localStorage.getItem("selectedClassConfirmStudentId");

    if (!academicYearId) {
      if (showNoDataAlert) {
        alert("Academic Year ID is required.");
      }
      return;
    }

    // Construct API URL
    let apiUrl = `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSConfirmRECORDFILTER/?academic_year_id=${academicYearId}`;
    if (selectedClassId) apiUrl += `&classId=${selectedClassId}`;
    if (selectedSectionId) apiUrl += `&sectionId=${selectedSectionId}`;
    if (statusData) apiUrl += `&statusdata=${statusData}`;
    if (studentId) apiUrl += `&studentId=${studentId}`;

    console.log("Constructed API URL:", apiUrl);

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json();
      console.log("API Response:", result);

      if (
        result.message === "success!!" &&
        result.data &&
        result.data.length > 0
      ) {
        setCurrentPage(0);
        setStudentsData(result.data); //  Data found, update table
      } else {
        setCurrentPage(0);
        setStudentsData([]); //  Clear table if no data
        if (showNoDataAlert) {
          alert("No data found.");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setCurrentPage(0);
      setStudentsData([]); //  Clear table on error too
      if (showNoDataAlert) {
        alert("An error occurred while fetching data.");
      }
    }
  };

  const handleSearch = async () => {
    await fetchConfirmStudents({ showNoDataAlert: true });
  };

  useEffect(() => {
    fetchConfirmStudents();

    const handleAcademicSessionChanged = () => {
      const updatedAcademicYearId = localStorage.getItem("academicSessionId");
      resetConfirmFilters();
      setStudentsData([]);
      fetchConfirmStudents({ academicYearId: updatedAcademicYearId });
    };

    window.addEventListener("academicSessionChanged", handleAcademicSessionChanged);

    return () => {
      window.removeEventListener(
        "academicSessionChanged",
        handleAcademicSessionChanged
      );
    };
  }, []);

  const handleInputChange = (e) => {
    if (isDisabled) return;

    const { name, value } = e.target;

    if (name === "house") {
      if (value) {
        localStorage.setItem("selectedHouseId", value);
      } else {
        localStorage.removeItem("selectedHouseId");
      }
    }

    if (name === "feeappfrom") {
      if (value) {
        localStorage.setItem("selectedFeeAppFromId", value);
      } else {
        localStorage.removeItem("selectedFeeAppFromId");
      }
    }

    if (name === "feegroup") {
      if (value) {
        localStorage.setItem("selectedFeeGroupId", value);
      } else {
        localStorage.removeItem("selectedFeeGroupId");
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleTransportAvailedChange = () => {
    if (isDisabled) return;
    const newValue = !isTransportAvailed;
    setIsTransportAvailed(newValue);

    const updatedMonths = Object.keys(selectedMonths).reduce((acc, month) => {
      acc[month] = newValue;
      return acc;
    }, {});

    setSelectedMonths(updatedMonths);

    const selectedMonthIds = Object.keys(updatedMonths)
      .filter((month) => updatedMonths[month])
      .map((month) => parseInt(month));

    setFormData((prevData) => ({
      ...prevData,
      transport_availed: newValue,
      choice_month: selectedMonthIds,
    }));

    localStorage.setItem("transport_availed", JSON.stringify(newValue));

    if (newValue) {
      localStorage.setItem("choice_month", JSON.stringify(selectedMonthIds));
    } else {
      localStorage.removeItem("choice_month");
    }
  };

  const handleMonthChange = (monthId) => {
    if (isDisabled) return;

    const isCurrentlySelected = selectedMonths[monthId] || false;

    const updatedMonths = {
      ...selectedMonths,
      [monthId]: !isCurrentlySelected,
    };

    setSelectedMonths(updatedMonths);

    const selectedMonthIds = Object.keys(updatedMonths)
      .filter((key) => updatedMonths[key] === true) // Only include months that are checked
      .map((key) => parseInt(key));

    setFormData((prevData) => ({
      ...prevData,
      choice_month: selectedMonthIds, // Pass the selected months array
    }));

    const currentMonths = JSON.parse(
      localStorage.getItem("choice_month") || "[]"
    );

    if (!isCurrentlySelected) {
      currentMonths.push(parseInt(monthId)); // Add to localStorage
      localStorage.setItem("choice_month", JSON.stringify(currentMonths));
    } else {
      const updatedStorageMonths = currentMonths.filter(
        (id) => id !== parseInt(monthId)
      );
      localStorage.setItem(
        "choice_month",
        JSON.stringify(updatedStorageMonths) // Update localStorage
      );
    }
  };

  const handleRouteChange = (e) => {
    if (isDisabled) return;

    const selectedRouteId = e.target.value;
    console.log("Selected Route ID:", selectedRouteId);

    if (!selectedRouteId) {
      localStorage.removeItem("selectedRouteId");
      setSelectedRoute("");
      setFormData((prevData) => ({
        ...prevData,
        routeid: "",
      }));
    } else {
      localStorage.setItem("selectedRouteId", selectedRouteId);
      setSelectedRoute(selectedRouteId);
      setFormData((prevData) => ({
        ...prevData,
        routeid: selectedRouteId,
      }));
    }
  };

  useEffect(() => {
    const savedRouteId = localStorage.getItem("selectedRouteId");
    if (savedRouteId) {
      setSelectedRoute(savedRouteId);
      setFormData((prev) => ({
        ...prev,
        routeid: savedRouteId,
      }));
    }
  }, []);

  const handlePickUpPointChange = (e) => {
    const selectedPickupPointId = e.target.value;

    if (!selectedPickupPointId) {
      localStorage.removeItem("selectedPickUpPointId");
      setSelectedPickUpPoint("");
      setFormData((prevData) => ({
        ...prevData,
        selectedPickUpPoint: "",
      }));
    } else {
      localStorage.setItem("selectedPickUpPointId", selectedPickupPointId);
      setSelectedPickUpPoint(selectedPickupPointId);
      setFormData((prevData) => ({
        ...prevData,
        selectedPickUpPoint: selectedPickupPointId,
      }));
    }
  };

  // useEffect(() => {
  //   // Set the stored status value when the page loads
  //   const storedStatus = localStorage.getItem("status");
  //   if (storedStatus) {
  //     document.getElementById("status").value = storedStatus;
  //   }
  // }, []);

  useEffect(() => {
    const storedStatus = localStorage.getItem("status");
    if (storedStatus) {
      const statusMap = {
        Promoted: { value: "A", label: "Promoted" },
        Demoted: { value: "B", label: "Demoted" },
        Fail: { value: "C", label: "Fail" },
      };
      setSelectedStatus(statusMap[storedStatus] || null);
    }
  }, []);

  // const handleStatusChange = (event) => {
  //   const statusValue = event.target.value;

  //   if (statusValue === "") {
  //     // If the "Select Status" option is selected, remove the status from localStorage
  //     localStorage.removeItem("status");
  //   } else {
  //     // Store the full status name (not just the value) in localStorage
  //     let statusName = "";
  //     switch (statusValue) {
  //       case "A":
  //         statusName = "Promoted";
  //         break;
  //       case "B":
  //         statusName = "Demoted";
  //         break;
  //       case "C":
  //         statusName = "Fail";
  //         break;
  //       default:
  //         statusName = "";
  //     }
  //     // Save the full name of the status
  //     localStorage.setItem("status", statusName);
  //   }
  // };

  const handleStatusChange = (event) => {
    const statusValue = event.target.value;

    if (statusValue === "") {
      localStorage.removeItem("status");
      setSelectedStatus(null);
    } else {
      let statusName = "";
      switch (statusValue) {
        case "A":
          statusName = "Promoted";
          break;
        case "B":
          statusName = "Demoted";
          break;
        case "C":
          statusName = "Fail";
          break;
        default:
          statusName = "";
      }
      localStorage.setItem("status", statusName);
    }
  };

  //New code
  //  Keep only one pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const studentsPerPage = 10;

  //  ReactPaginate handler
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  //  Slice studentsData based on page
  const offset = currentPage * studentsPerPage;
  const currentStudents = studentsData.slice(offset, offset + studentsPerPage);

  //  Page count based on studentsData
  const pageCount = Math.ceil(studentsData.length / studentsPerPage);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT CONFIRM
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={handleSearch}
                    style={{
                      width: "150px",
                    }}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    onClick={() => navigate("/admin/dashboard")}
                    style={{
                      width: "150px",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box ">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-4 mt-3">
                      <div className="col-12 col-md-3 ">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            disabled={isInputDisabled}
                            ref={studentNameRef}
                            onInput={(e) => {
                              if (!e.target.value.trim()) {
                                localStorage.removeItem(
                                  "selectedClassConfirmStudentId"
                                );
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={() => setShowStudentSelectionModal(true)}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <ModalConfirm
                        show={showStudentSelectionModal}
                        handleClose={handleModalClose}
                        onSelectStudent={(student) => {
                          const studentDetails = student; // Use the student object directly
                          const studentId = studentDetails.studentId; // Access studentId directly

                          // Construct full name with handling for middle name
                          studentNameRef.current.value = `${studentDetails.studentname}`;

                          localStorage.setItem(
                            "selectedClassConfirmStudentId",
                            studentId
                          );

                          handleModalClose(); // Close the modal
                        }}
                      />
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="admitted-class" className="form-label">
                          Class<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          className=" detail"
                          id="admitted-class"
                          options={classes.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.classname,
                          }))}
                          value={
                            classes
                              .map((classItem) => ({
                                value: classItem.id,
                                label: classItem.classname,
                              }))
                              .find(
                                (option) => option.value === formData.classId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleClassChange({
                              target: {
                                value: selectedOption
                                  ? selectedOption.value
                                  : "",
                              },
                            })
                          }
                          placeholder="Select Class"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label
                          htmlFor="admitted-section"
                          className="form-label"
                        >
                          Section
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          className=" detail"
                          id="admitted-section"
                          options={sections.map((section) => ({
                            value: section.section_id,
                            label: section.sectionname,
                          }))}
                          value={
                            sections
                              .map((section) => ({
                                value: section.section_id,
                                label: section.sectionname,
                              }))
                              .find(
                                (option) => option.value === formData.sectionId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: {
                                value: selectedOption
                                  ? selectedOption.value
                                  : "",
                              },
                            })
                          }
                          placeholder="Select Section"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <Select
                          id="status"
                          className="detail"
                          options={[
                            { value: "A", label: "Promoted" },
                            { value: "B", label: "Demoted" },
                            { value: "C", label: "Fail" },
                          ]}
                          placeholder="Select Status"
                          isClearable
                          value={selectedStatus}
                          onChange={(selectedOption) => {
                            setSelectedStatus(selectedOption);
                            handleStatusChange({
                              target: {
                                value: selectedOption
                                  ? selectedOption.value
                                  : "",
                              },
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Student Name</th>
                        <th>Registration No</th>
                        <th>BarCode</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Father Name</th>
                        <th>Mother Name</th>
                        <th>Status</th>
                        <th>Confirm</th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentsData.length === 0 ? (
                        <tr>
                          <td colSpan="10" style={{ textAlign: "center" }}>
                            No data available
                          </td>
                        </tr>
                      ) : (
                        currentStudents.map((student, index) => (
                          <tr key={student.id}>
                            <td>{currentPage * studentsPerPage + index + 1}</td>
                            <td>{student.studentname}</td>
                            <td>{student.registration_no || "-"}</td>
                            <td>{student.barcode}</td>
                            <td>{student.classname}</td>
                            <td>{student.sectionname}</td>
                            <td>{student.fatherName}</td>
                            <td>{student.motherName}</td>
                            <td>{student.student_status}</td>
                            <td>
                              <button
                                className="btn btn-warning"
                                onClick={() => handleEditClick(student)}
                              >
                                Confirm
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  {studentsData.length > studentsPerPage && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={
                        "pagination justify-content-center mt-3"
                      }
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showEditModal && selectedStudent && (
        <div className="modal show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Student Details</h5>
              </div>

              <div
  className="modal-body"
  style={{
    padding: "25px",
  }}
>
                <div className="row mb-3">
  <div
    className="col-12 py-2 px-3"
    style={{
      border: "1px solid #ccc",
      background: "#fafafa",
    }}
  >
    <h5 className="mb-0 fw-bold">
      Student Details
    </h5>
  </div>
</div>
                <div
  className="row g-3 mb-4 align-items-end"
  style={{
    marginTop: "8px",
  }}
>
                  <div className="col-12 col-md-3 mb-4">
                    <label
  className="form-label"
  style={{
    marginBottom: "8px",
    fontWeight: "600",
  }}
>Student Name</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.studentname}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-4">
                    <label
  className="form-label"
  style={{
    marginBottom: "8px",
    fontWeight: "600",
  }}
>Admission No</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.school_admission_no}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-4">
                    <label
  className="form-label"
  style={{
    marginBottom: "8px",
    fontWeight: "600",
  }}
>Student Barcode</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.barcode}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-3 mb-4">
                    <label
  className="form-label"
  style={{
    marginBottom: "8px",
    fontWeight: "600",
  }}
>Father Name</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.father_name}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-4 mb-4">
                    <label
  className="form-label"
  style={{
    marginBottom: "8px",
    fontWeight: "600",
  }}
>Mother Name</label>
                    <input
                      type="text"
                      className="form-control detail"
                      value={selectedStudent.mother_name}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-md-4 mb-4">
                    <label
                      htmlFor="admitted-class"
                      className="form-label"
                      style={{ marginBottom: "8px", fontWeight: "600" }}
                    >
                      Admitted Class<span style={{ color: "red" }}>*</span>
                    </label>
                    {classLoading ? (
                      <p>Loading classes...</p>
                    ) : classError ? (
                      <p style={{ color: "red" }}>
                        Error loading classes: {classError}
                      </p>
                    ) : (
                      <select
                        id="admitted-class"
                        className="form-select detail"
                        value={formData.classId}
                        disabled
                        onChange={handleClassChange}
                        required
                      >
                        <option value="">Select Class</option>
                        {classes.map((classItem) => (
                          <option key={classItem.id} value={classItem.id}>
                            {classItem.classname}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>

                  <div className="col-12 col-md-4 mb-4">
                    <label
                      htmlFor="admitted-section"
                      className="form-label"
                      style={{ marginBottom: "8px", fontWeight: "600" }}
                    >
                      Admitted Section
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    {sectionLoading ? (
                      <p>Loading sections...</p>
                    ) : sectionError ? (
                      <p>Error loading sections: {sectionError}</p>
                    ) : (
                      <select
                        id="admitted-section"
                        className="form-select detail"
                        value={formData.sectionId}
                        disabled
                        onChange={handleSectionChange}
                        required
                      >
                        <option value="">Select Section</option>
                        {sections.map((section) => (
                          <option
                            key={section.section_id}
                            value={section.section_id}
                          >
                            {section.sectionname}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>

                <div className="row mb-4 mt-2">
  <div
    className="col-12 py-2 px-3"
    style={{
      border: "1px solid #ccc",
      background: "#fafafa",
    }}
  >
    <h5 className="mb-0 fw-bold">
      Student Class Details
    </h5>
  </div>
</div>
                

                <div className="row">
                  <div className="col-12 border">
                    <div className="row g-3 mb-4">
                      <div className="col-12 col-md-6 mb-4">
                        <label htmlFor="fee-app-from" className="form-label">
                          Fee App From<span style={{ color: "red" }}>*</span>
                        </label>
                        {error ? (
                          <p style={{ color: "red" }}>{error}</p>
                        ) : (
                          <select
                            id="fee-app-from"
                            className="form-select"
                            value={formData.feeappfrom}
                            onChange={handleInputChange}
                            name="feeappfrom"
                            disabled={isDisabled}
                          >
                            <option value="">Select Fee App From</option>
                            {periods.map((period) => (
                              <option key={period.id} value={period.id}>
                                {period.period_name}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      <div className="col-12 col-md-6 mb-4">
                        <label htmlFor="fee-group" className="form-label">
                          Fee Group<span style={{ color: "red" }}>*</span>
                        </label>
                        {feeLoading ? (
                          <p>Loading fee groups...</p>
                        ) : feeError ? (
                          <p style={{ color: "red" }}>
                            Error loading fee groups: {feeError}
                          </p>
                        ) : (
                          <select
                            id="fee-group"
                            className="form-select"
                            value={formData.feegroup}
                            onChange={handleInputChange}
                            name="feegroup"
                            disabled={isDisabled}
                          >
                            <option value="">Select Fee Group</option>
                            {feeGroups.length > 0 ? (
                              feeGroups.map((feeGroup) => (
                                <option key={feeGroup.id} value={feeGroup.id}>
                                  {feeGroup.feestructuredesc}
                                </option>
                              ))
                            ) : (
                              <option value="" disabled>
                                No fee groups available
                              </option>
                            )}
                          </select>
                        )}
                      </div>
                    </div>
                    <div
  className="col-12 py-2 px-3 mt-3 mb-3"
  style={{
    border: "1px solid #ccc",
    background: "#fafafa",
  }}
>
  <h5 className="mb-0 fw-bold">
    Transport Details
  </h5>
</div>
                    <Form.Check
  type="checkbox"
  className="mt-3 mb-4 d-flex align-items-center"
                      style={{ fontWeight: "700" }}
                      checked={isTransportAvailed}
                      onChange={handleTransportAvailedChange}
                      disabled={isDisabled}
                      label={
                        <span style={{ marginLeft: "10px" }}>
                          Transport Availed
                        </span>
                      }
                    />

                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #ccc",

                        padding: "15px",
                        marginBottom: "20px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {Object.keys(selectedMonths).map((monthId) => (
                        <div
                          key={monthId}
                          style={{
                            flex: "1 1 calc(25% - 10px)",
                            minWidth: "100px",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            id={`month-checkbox-${monthId}`} // Unique ID for accessibility
                            label={
                              periods.find(
                                (period) => period.id === parseInt(monthId)
                              )?.period_name || `Month ${monthId}`
                            } // Default fallback label
                            checked={selectedMonths[monthId] || false}
                            onChange={() => handleMonthChange(monthId)}
                            disabled={!isTransportAvailed || isDisabled}
                          />
                        </div>
                      ))}
                    </div>

                    <Row className="mt-4 g-3">
                      <Col md={6} className="mb-4">
                        <Form.Group controlId="formRoute">
                          <Form.Label>Route</Form.Label>
                          <Form.Select
                            onChange={handleRouteChange}
                            disabled={!isTransportAvailed || isDisabled}
                            value={selectedRoute || ""}
                          >
                            <option value="">Select Route</option>
                            {routeLoading && <option>Loading...</option>}
                            {routeError && (
                              <option>Error loading routes</option>
                            )}
                            {!routeLoading &&
                              !routeError &&
                              routes.map((route) => (
                                <option key={route.id} value={route.id}>
                                  {route.transportname}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-4">
                        <Form.Group controlId="formPickUpPoint">
                          <Form.Label>Pick Up Point</Form.Label>
                          <Form.Select
                            onChange={handlePickUpPointChange}
                            disabled={
                              !isTransportAvailed ||
                              !formData.routeid
                            }
                            value={selectedPickUpPoint || ""}
                          >
                            <option value="">Select Pick Up Point</option>
                            {pickupLoading && <option>Loading...</option>}
                            {pickupError && (
                              <option>
                                Error loading pick-up points: {pickupError}
                              </option>
                            )}
                            {!pickupLoading &&
                              !pickupError &&
                              pickupPoints.map((pickupPoint) => (
                                <option
                                  key={pickupPoint.routeDetailsId}
                                  value={pickupPoint.routeDetailsId}
                                >
                                  {pickupPoint.pickup_point_name}{" "}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setFormData({
                      rollno: "",
                      classId: "",
                      sectionId: "",
                      house: "",
                      feeappfrom: "",
                      feegroup: "",
                    });

                    setSelectedClassId("");
                    setAmount("");
                    setSelectedRoute("");
                    setSelectedPickUpPoint("");

                    localStorage.removeItem("selectedStudentClassId");
                    localStorage.removeItem("selectedStudentSectionId");
                    localStorage.removeItem("selectedHouseId");
                    localStorage.removeItem("selectedFeeAppFromId");
                    localStorage.removeItem("selectedFeeGroupId");
                    localStorage.removeItem("selectedRouteId");
                    localStorage.removeItem("selectedPickUpPointId");

                    localStorage.removeItem("choice_month");
                  }}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleModalClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveChanges}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdmAttendanceEntry;
